// ── AccountForm ──
import { useState, useEffect } from "react";
import { B } from "../../../shared/theme";
import { Btn, FInput, FSelect, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const AccountForm = ({ initial, readOnly }) => {
    const { api, role, modal, setModal, closeModal, saving, error, saveRec, app } = useApp();
    const [f, set] = useFreshForm(initial||{
      companyname:"", companyphone:"", companyemail:"", status:"Active",
      street:"", city:"", state:"", zip:"", country:"United States",
      account_manager:"", accountnumber:"", industryid:"", website:"", box_folder_id:"", bbc_box_folder_id:""
    }, "Accounts");
    const [users, setUsers] = useState([]);
    const [industryList, setIndustryList] = useState([]);
    useEffect(()=>{
      api.get("getUsers?filter=isaccountmanager").then(d=>setUsers(d)).catch(()=>setUsers([]));
      api.get("getIndustry").then(d=>setIndustryList(d)).catch(()=>setIndustryList([]));
    },[]);

    const userOptions = [{ value:"", label:"— Select —" }, ...users.map(u=>({ value:u.id, label:u.FullName+" ("+u.Role+")" }))];
    const ST = ({ title }) => <div style={{ gridColumn:"1/-1", fontSize:11, fontWeight:600, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.06em", marginTop:18, marginBottom:8, paddingBottom:4, borderBottom:"1.5px solid "+B.cyanLight }}>{title}</div>;

    return <Modal title={readOnly?"View Account":initial?"Edit Account":"Add Account"} onClose={closeModal} wide
      onEdit={readOnly&&role.canEdit?()=>{ closeModal(); setModal({type:"account-edit",rec:initial,onDone:modal.onDone}); }:null}>
      <ReadOnlyForm readOnly={readOnly}>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", gap:"0 24px" }}>
          <ST title="Account Info" />
          <Field label="Account Number">
            <div style={{ padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #ddd", background:"#f5f5f5", color:"#888" }}>
              {f.accountnumber||"—"}
            </div>
          </Field>
          <Field label="Company Name" ><FInput value={f.companyname||""} onChange={set("companyname")} /></Field>
          <Field label="Account Manager"><FSelect value={f.account_manager||""} onChange={set("account_manager")} options={userOptions} /></Field>
          <div /><div /><div />

          <ST title="Industry" />
          <Field label="Industry" style={{ gridColumn:"span 2" }}>
            <select
              value={f.industryid||""}
              onChange={e=>set("industryid")(e.target.value)}
              disabled={readOnly}
              style={{ width:"100%", boxSizing:"border-box", padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #999", background: readOnly?"#f5f5f5":"#fff", color:"#1a1a1a" }}
            >
              <option value="">— Select Industry —</option>
              {industryList.map(i=>(
                <option key={i.id} value={i.id}>
                  {i.naicscode ? `${i.naicscode} — ` : ""}{i.industry}
                </option>
              ))}
            </select>
          </Field>
          <div /><div />

          <ST title="Box Integration" />
            <Field label="Servicing Folder ID">
              <FInput value={f.box_folder_id||""} onChange={set("box_folder_id")}
                placeholder="e.g. 123456789" />
            </Field>
            <Field label="Borrowing Base Folder ID">
              <FInput value={f.bbc_box_folder_id||""} onChange={set("bbc_box_folder_id")}
                placeholder="e.g. 123456789" />
            </Field>
            <div style={{ gridColumn:"1/-1", fontSize:11, color:"var(--color-text-secondary)", marginTop:-8, marginBottom:8 }}>
              Numeric ID from the end of the Box folder URL (app.box.com/folder/<strong>123456789</strong>). Servicing = "07. Servicing"; Borrowing Base = "04. Borrowing Base Package" (used to auto-link uploaded BBCs).
            </div>
            <div /><div />

          <ST title="Contact" />
            <Field label="Company Phone"><FInput value={f.companyphone||""} onChange={set("companyphone")} /></Field>
            <Field label="Company Email"><FInput value={f.companyemail||""} onChange={set("companyemail")} /></Field>
            <Field label="Website"><FInput value={f.website||""} onChange={set("website")} placeholder="https://" /></Field>

          <div />

          <ST title="Address" />
          <Field label="Street" ><FInput value={f.street||""} onChange={set("street")} /></Field>
          <Field label="City"   ><FInput value={f.city||""}   onChange={set("city")}   /></Field>
          <Field label="State"  ><FInput value={f.state||""}  onChange={set("state")}  /></Field>
          <Field label="Zip"    ><FInput value={f.zip||""} onChange={set("zip")} /></Field>
          <Field label="Country"><FInput value={f.country||""} onChange={set("country")} /></Field>
        </div>
      </ReadOnlyForm>
      {!readOnly&&error&&<div style={{ color:"#993C1D",fontSize:12,marginBottom:8,marginTop:8 }}>{error}</div>}
      <div style={{ display:"flex",gap:8,justifyContent:"flex-end",marginTop:16 }}>
        <Btn onClick={closeModal}>{readOnly?"Close":"Cancel"}</Btn>
      {!readOnly&&<Btn disabled={saving} onClick={()=>saveRec("saveAccount",f,initial?"Edited":"Added","Accounts",(initial?"Updated":"Added")+" account: "+f.companyname,modal.onDone)} variant="primary">{saving?"Saving...":"Save"}</Btn>}

      </div>
    </Modal>;
  };
